<template>

  <div class="screen-container">

    <div class="screen screen-1">
        <div class="screen-text">
          <p>Delicious and Healthy Korean Cuisine</p>
        </div>
    </div>

    <div class="screen screen-2">
       <div class="screen-text">
          <p>Dine-In, Take-Out, Order for Delivery</p>
       </div>
    </div>
  </div>



</template>

<script>

  export default {
    name: 'HomeHeader1'
  }

</script>
  
<style scoped>


.screen-container {

    position: relative;
    overflow: hidden;
    width: 100%;
    height: 80px;
    margin-top: 10p
  }    

  .screen {
    position: absolute;
    width: 100%;
    height: 80px;
    opacity: 0;
    pointer-events: none; /* Prevent interaction when not visible */
    animation-duration: 14s;
    animation-timing-function: step-end; /* for instant change of screen */
    animation-iteration-count: infinite;
  }

  /* Distinct styling for individual items */
  .screen-1 {
    animation-name: displayScreen1;
    background-color: #cde8a1;
    color: darkblue;
    font-weight: bold;
  }

  .screen-2 {
    animation-name: displayScreen2;
    background-color: #fcc6bb;
    color: darkblue;
    font-weight: bold;
  }

  .screen-text {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    font-size: 1.2rem;
  }


  /* Keyframes for Screen-1 */
  @keyframes displayScreen1 {
    
    0% { opacity: 1; pointer-events: auto; } /* Fully visible and interactive */
    50% { opacity: 0; pointer-events: none; } /* Fully invisible
    100% { opacity: 0; pointer-events: none; } /* Fully invisible and non-interactive */
    }

  /* Keyframes for Screen-2 */
  @keyframes displayScreen2 {
    
    0% { opacity: 0; pointer-events: none; } 
    50% { opacity: 1; pointer-events: auto; } 
    100% { opacity: 0; pointer-events: none; }
    }

</style>